module.exports = __webpack_public_path__ + "3b821f868794fcc048d67b4afea13978.svg";